

import { Button } from 'antd';
import React from 'react';
import { useRouteError ,Link} from "react-router-dom";


const ErrorPage = () => {
      const error = useRouteError();
  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
      <br />
      <br />
      <Link to="/cwc-support/dashboard">Return to Home Page</Link>
    </div>
  );
}

export default ErrorPage